export const CONTACT_NAME_REGEX = /^[A-Za-z0-9\s{}()\[\],.\-_@&'É`;"ÇÂ]*$/;